import type { MutationHookOptions } from '@apollo/client'
import {
  EditTrainingQueryDocument,
  UpdateTrainingInternalInfoDocument,
  UpdateTrainingInternalInfoMutation,
  UpdateTrainingInternalInfoMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingInternalInfoMutation,
  UpdateTrainingInternalInfoMutationVariables
>

export const useUpdateTrainingInternalInfo = (options?: Options) => {
  const [updateInternalInfoTraining, { loading }] = useMutation(
    UpdateTrainingInternalInfoDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.updateInternalInfoTrainingsTraining,
      refetchQueries: [EditTrainingQueryDocument],
      awaitRefetchQueries: true,
    }
  )

  return {
    loading,
    updateInternalInfoTraining(variables: UpdateTrainingInternalInfoMutationVariables) {
      return updateInternalInfoTraining({
        variables,
      })
    },
  }
}
